import React, { useContext, useRef, useState } from 'react';
import './modalventas.css';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import authContext from '../../context/auth/authContext.js'
import { useDispatch, useSelector } from 'react-redux';
import { SkuButtonFlowListener } from '../sku/SkuDetailFlowButtons';
import { SkuProcessEngine } from '../sku/utils/SkuProcessEngine';
import { SkuLoader } from '../sku/SkuLoader';
import { RootState } from '../../presentation/redux/store/RootState';
import { SaleActions } from '../../presentation/redux/actions/SaleActions';
import { RequestParam } from '../../domain/models/RequestParam';
import { SkuParamListener } from '../../domain/models/SkuDetail';
import { ModalStep } from '../../presentation/redux/states/SaleState';
import { SkuList } from '../sku/SkuList';
import { Sku } from '../../domain/models/Sku';
import { SkuModalSection } from '../../domain/constants/SkuModalSection';
import { SkuWebComponent } from '../../domain/constants/SkuWebComponent';
import jsPDF from 'jspdf';
import domtoimage from 'dom-to-image';
import logo from '../../assets/img/logo-final.svg';
import loadingImg from '../login/loading.png'
import { applog } from '../../domain/utils/applog';
import { SkuSaleConfirmation } from '../sku/SkuSaleConfirmation';
import { Alert } from 'react-bootstrap';
import ReactToPrint from "react-to-print";
//import { RemoteConstants } from '../../data/remote/RemoteConstants';
import { fetchLogoFromLocalStorage } from '../action/fetchLogoById';
import { balanceRequest2 } from '../action/saldoServicios/consultaSaldo';

/* 
@page {
        size: 58mm;
        }
        @page {
            margin: 0;
            size: a4 !important;
          }
*/
export function ModalVentas() {

    const state = useSelector((s: RootState) => s.saleState);
    const dispatch = useDispatch();
    const AuthContext = useContext(authContext);
    const { puntoVenta, token } = AuthContext;
    let componentRef = useRef<null | HTMLParagraphElement>(null);
    const [logoUrl, setLogoUrl] = useState(loadingImg);
    const skuProcessedRef = useRef<string | null>(null);

    let id = localStorage.getItem("dst_Id");

    const pageStyle = `
        @media print {
        @media all { 
                        img {
                            display: none; 
                            margin-left: auto;
                            margin-right: auto;
                            height: 20%; 
                            width: 20%;
                            opacity: 0.4;
                            margin-bottom: 10px;
                        }
                        .toPrint {
                            border: 1px solid #ededed;
                            padding: 10px;
                             font-size: 12px;
                             width: 58mm;
                             text-align: center;
                        }
                        .toPrint span {
                            font-size: 11px;
                            margin-right: 1pt;
                            margin-bottom: 10px;
                        }
                        .toPrint span::after {
                            content: ':';
                        }
                    }
                }
            }`;

    function handleNextStep(param: RequestParam) {
        if (state.sku?.sku === 'ACCESOD_ACTIVACION' && param.name === 'ref') {
            dispatch(SaleActions.processActivationQR(state.sku.sku, token, param.value));
            return;
        }

        dispatch(SaleActions.nextStep(
            state.step,
            state.elementsInBody,
            [...state.params,
                param],
            puntoVenta,
            token
        ));
    }

    function handleParamChange(nameParam: string, value: any) {
        const param = new RequestParam(nameParam, value, nameParam, false);
        dispatch(SaleActions.addParams([param]));
    }

    function handlePreviousStep() {
        dispatch(SaleActions.prevStep(state.step, state.modalStep));
    }

    function handlePdf() {
        const input = document.getElementById('divToPrint');
        const pdf = new jsPDF('p');


        dispatch(SaleActions.hideTicketFailed());
        dispatch(SaleActions.showLoader('Preparando impresión...'));
        if (pdf && input) {

            let height = input.clientHeight;
            let width = input.clientWidth;
            let aspectRatio = height / width;
            let pdfWidth = 190;
            applog('Image', 'w', width);
            applog('Image', 'h', height);
            applog('Image', 'a', aspectRatio);

            domtoimage.toPng(input)
                .then((imgData) => {
                    pdf.addImage(imgData, 'PNG', 10, 10, pdfWidth, pdfWidth * aspectRatio);
                    pdf.save('ticket-redsmart.pdf');
                    dispatch(SaleActions.hideLoader());
                }).catch((e: any) => {
                    applog('PDF', 'Error', e);
                    dispatch(SaleActions.hideLoader());
                    dispatch(SaleActions.showTicketFailed());
                });
        }
    }

    React.useEffect(() => {
        if (state.setup.sku && state.modalShow && skuProcessedRef.current !== state.setup.sku.sku) {
            skuProcessedRef.current = state.setup.sku.sku;
            dispatch(SaleActions.setSku(state.setup.sku));
            dispatch(SaleActions.selectSku(state.setup.sku));
        }
        
        if (!state.modalShow) {
            skuProcessedRef.current = null;
        }
        
        const fetchLogo = async () => {
            try {
                if (id) {
                    const url = await fetchLogoFromLocalStorage(id);
                    if (url) {
                        setLogoUrl(url);
                    } else {
                        setLogoUrl(logo);
                    }
                } else {
                    setLogoUrl(logo);
                }
            } catch (error) {
                setLogoUrl(logo);
            }
        };

        fetchLogo();
    }, [state.setup.sku, state.modalShow, dispatch, id])

    React.useEffect(() => {
        if (state.sku?.sku === 'ACCESOD_ACTIVACION' && token) {
            const tokenParam = new RequestParam('token', token, 'Token', true);
            dispatch(SaleActions.addParams([tokenParam]));
        }
    }, [state.sku?.sku, token, dispatch])

    const handleHide = () => {
        dispatch(SaleActions.reset());
        dispatch(SaleActions.close());
    }

    function getBodyElement() {
        const section = state?.elementsInBody[state?.step ?? 0];
        const isFirstStep = (state?.step ?? 0) === 0;
        
        return section &&
            SkuProcessEngine.getComponent(section,
                new SkuButtonFlowListener({
                    onBackPressed: isFirstStep ? undefined : handlePreviousStep,
                    onContinuePressed: handleNextStep
                }),
                new SkuParamListener(handleParamChange)
            )
    }

    function getTicketBodyElements() {
        return state.result?.elements?.filter((section) => {
            return section.modalSection !== SkuModalSection.Footer &&
                section.webComponent !== SkuWebComponent.LabelTitle;
        }).map((section) => {
            return (<>
                {SkuProcessEngine.getComponent(section)}
            </>);
        }) ?? <></>
    }

    function getSkuHeader() {
        // No mostrar imagen cuando es una activación de QR
        if (state.sku?.sku === 'ACCESOD_ACTIVACION') {
            const hasActivationInfo = state.elementsInBody.some(
                element => element.webComponent === 'activation-info'
            );
            
            if (hasActivationInfo) {
                return state.sku && state.skuDetail &&
                    (<div className="d-flex flex-column w-100 align-items-center justify-content-center mb-2">
                        <div className="d-flex flex-column">
                            {SkuProcessEngine.getHeaderComponents(state.skuDetail?.elements ?? [])}
                        </div>
                    </div>)
            }
        }
        
        return state.sku &&
            (<div className="d-flex flex-column w-100 align-items-center justify-content-center mb-2">
                {
                    state.sku &&
                    <img className="skuimg-title"
                        src={state.sku.logoPath} alt={state.sku.skuName} />
                }
                {
                    state.skuDetail &&
                    <div className="d-flex flex-column">
                        {SkuProcessEngine.getHeaderComponents(state.skuDetail?.elements ?? [])}
                    </div>
                }
            </div>)
    }

    function getMessages() {
        if (state.sku?.sku === 'ACCESOD_ACTIVACION') {
            const hasActivationInfo = state.elementsInBody.some(
                element => element.webComponent === 'activation-info'
            );
            
            if (hasActivationInfo) {
                return null;
            }
        }

        return state.skuDetail &&
            (<div key="messages">
                {SkuProcessEngine.getAllMessagesComponents(state.skuDetail?.elements ?? [])}
            </div>)
    }

    //[Balance Step 11]: Renderiza los componentes de saldo si hay valor en 'destination' y se está en el paso 1.
    function getBalanceInfo() {
        if (state.sku?.sku === 'ACCESOD_ACTIVACION') {
            const hasActivationInfo = state.elementsInBody.some(
                element => element.webComponent === 'activation-info'
            );
            
            if (hasActivationInfo) {
                return null;
            }
        }

        const destinationParam = state.params.find(param => param.name === 'destination');
        const hasDestinationValue = destinationParam && destinationParam.value;

        if (hasDestinationValue && state.skuDetail && state.step === 1) {
            return (
                <div key="balance-info">
                    {SkuProcessEngine.getAllBalanceComponents(state.skuDetail.elements ?? [])}
                </div>
            );
        }

        return null;
    }

    function getLoader() {
        return (state.loader.isLoading) &&
            (<SkuLoader message={state.loader.message} />)
    }

    //[Balance Step 12]: Ejecuta la solicitud de saldo (balanceRequest2) automáticamente si se cumplen las condiciones requeridas.
    React.useEffect(() => {
        const destinationParam = state.params.find(param => param.name === 'destination');
        const destinationSku = state.sku?.sku;
        const hasDestinationValue = destinationParam && destinationParam.value;

        const hasInputClientBalance = state.skuDetail?.elements?.some(
            element => element.webComponent === "input-client-balance"
        );


        if (hasDestinationValue &&
            state.skuDetail &&
            hasInputClientBalance &&
            state.step === 1 &&
            state.modalStep === 1) {
            // dispatch(SaleActions.loadingBalance());
            dispatch(balanceRequest2(token, destinationParam.value, destinationSku));
        }
    }, [state.params, state.skuDetail, state.step, token, dispatch, state.modalStep, state.sku?.sku]);

    return (<Modal
        id="modal"
        show={state.modalShow}
        onHide={handleHide}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
    >
        <Modal.Header
            className='gradientBlue colorWhite'
            closeButton>
            <Modal.Title id="contained-modal-title-vcenter" >
                {state.setup.title}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body
            className="modal-venta">
            <div className='d-flex flex-column'>
                {
                    state.pdfFailed &&
                    <>
                        <Alert variant="warning" className="mx-4 my-4">
                            <div className="row align-items-center">
                                <div className="text-center col-8">Hubo un error al generar el ticket</div>
                                <div className="col-4 btn btn-link"
                                    onClick={() => {
                                        handlePdf();
                                    }}>Reintentar</div>
                            </div>
                        </Alert>
                    </>
                }
                <div className='toPrint' id='divToPrint' ref={componentRef}>
                    {
                        !state.sku && !state.setup.sku &&
                        <SkuList options={state.setup.options} handleSetSku={(sku: Sku) => {
                            dispatch(SaleActions.setSku(sku));
                            dispatch(SaleActions.selectSku(sku));
                        }} />
                    }

                    {/* SKU */}
                    {getSkuHeader()}
                    {
                        state.modalStep === ModalStep.SKU_SALE &&
                        (<>
                            <div>
                                {getBalanceInfo()}
                                {getMessages()}
                                {getBodyElement()}
                            </div>
                        </>)
                    }
                    <div>
                        {
                            state.modalStep === ModalStep.CONFIRM &&
                            <>
                                <SkuSaleConfirmation params={state.params}
                                    pos={puntoVenta}
                                    step={state.step}
                                    token={token}
                                />
                            </>
                        }
                        {
                            (state.modalStep === ModalStep.SKU_RESULT) &&
                            (<>
                                {!state.pdfFailed &&
                                    <img
                                        alt='Redsmart'
                                        style={state.sku?.sku === 'ACCESOD_ACTIVACION' ? {
                                            position: 'absolute',
                                            top: '50px',
                                            left: '40%',
                                            height: 'auto',
                                            width: '20%',
                                            opacity: '0.4',
                                            zIndex: 0
                                        } : {
                                            position: 'absolute',
                                            top: '180px',
                                            left: '40%',
                                            height: 'auto',
                                            width: '20%',
                                            opacity: '0.4'
                                        }}
                                        src={logoUrl} />
                                }
                                {getTicketBodyElements()}
                            </>)
                        }
                    </div>
                </div>
                {getLoader()}
            </div>
        </Modal.Body>
        {
            state.modalStep === ModalStep.SKU_RESULT &&
            <Modal.Footer>
                <ReactToPrint
                    trigger={() => <Button className='bgAccent colorWhite float-left ml-4' variant="contained" color="primary">Imprimir</Button>}
                    content={() => componentRef.current}
                    copyStyles={false}
                    pageStyle={pageStyle}
                />
                <Button
                    variant="accent" className="btn-download colorWhite float-left"
                    onClick={() => {
                        handlePdf();
                    }}>   Descargar   </Button>
                <Button
                    variant="primary" className="float-right mr-4"
                    onClick={() => {
                        handleHide();
                    }}>   Cerrar   </Button>
            </Modal.Footer>
        }
    </Modal >

    );
}
